import React, { useEffect, useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

function LiveStats() {
  const [stats, setStats] = useState({ bloodDraws: 0, phlebotomists: 0, doctors: 0, patients: 0, loading: true });

  const fetchStats = useCallback(async () => {
    try {
      setStats(prev => ({ ...prev, loading: true }));

      const [{ count: bloodDrawsCount }, { count: phlebotomistsCount }, { count: doctorsCount }, { count: patientsCount }] = await Promise.all([
        supabase.from('submissions').select('*', { count: 'exact', head: true }).eq('status', 'completed'),
        supabase.from('phlebotomist_profiles').select('*', { count: 'exact', head: true }),
        supabase.from('doctors').select('*', { count: 'exact', head: true }),
        supabase.from('patients').select('*', { count: 'exact', head: true })
      ]);

      setStats({
        bloodDraws: bloodDrawsCount || 0,
        phlebotomists: phlebotomistsCount || 0,
        doctors: doctorsCount || 0,
        patients: patientsCount || 0,
        loading: false
      });
    } catch (e) {
      console.error('Failed to fetch live stats', e);
      setStats(prev => ({ ...prev, loading: false }));
    }
  }, []);

  useEffect(() => {
    fetchStats();

    const subscriptions = [];
    const push = sub => { subscriptions.push(sub); return sub; };

    push(supabase.channel('submissions_changes').on('postgres_changes', { event: '*', schema: 'public', table: 'submissions' }, fetchStats).subscribe());
    push(supabase.channel('phlebotomists_changes').on('postgres_changes', { event: '*', schema: 'public', table: 'phlebotomist_profiles' }, fetchStats).subscribe());
    push(supabase.channel('doctors_changes').on('postgres_changes', { event: '*', schema: 'public', table: 'doctors' }, fetchStats).subscribe());
    push(supabase.channel('patients_changes').on('postgres_changes', { event: '*', schema: 'public', table: 'patients' }, fetchStats).subscribe());

    return () => { subscriptions.forEach(s => supabase.removeChannel(s)); };
  }, [fetchStats]);

  const StatBox = ({ label, value, id }) => (
    <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: 6, textAlign: 'center', border: '1px solid #e5e7eb' }} data-stat-label={label}>
      <div id={id} style={{ fontSize: 18, fontWeight: 700, color: '#0066cc' }}>{value}</div>
      <div style={{ fontSize: 12, color: '#6b7280' }}>{label}</div>
    </div>
  );

  return (
    <div style={{ maxWidth: 960, margin: '24px auto', padding: '0 16px' }}>
      <h1 style={{ fontSize: 24, marginBottom: 8, color: '#1f2937' }}>Live Company Stats</h1>
      <p style={{ marginBottom: 16, color: '#4b5563' }}>These statistics update in real-time to showcase platform traction.</p>
      {stats.loading ? (
        <div style={{ color: '#6b7280' }}>Loading…</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12 }}>
          <StatBox id="stat-blood-draws" label="Blood Draws" value={stats.bloodDraws} />
          <StatBox id="stat-phlebotomists" label="Phlebotomists" value={stats.phlebotomists} />
          <StatBox id="stat-doctors" label="Doctors" value={stats.doctors} />
          <StatBox id="stat-patients" label="Patients" value={stats.patients} />
        </div>
      )}
    </div>
  );
}

export default LiveStats;


